import { callApiWithAuthorization } from "../CallApi";

export async function getActiveProducts() {
    const request = await callApiWithAuthorization("/api/v0/payment/activeProducts");
    const response = await request.json();
    return response;
}

export async function createCheckoutUrl(customerId, priceId, quantity) {
    const request = await callApiWithAuthorization("/api/v0/payment/checkout", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ customerId, priceId, quantity }),
    });
    const response = await request.json();
    return response.url;
}

export async function checkIfCustomerHasPaymentMethodSetup(organizationId) {
    const request = await callApiWithAuthorization("/api/v0/organization/" + organizationId + "/hasPaymentMethod");
    const response = await request.json();
    return response.customerHasPaymentMethod;
}

export async function getCurrentSubscriptionForOrganisation(organisationId) {
    const request = await callApiWithAuthorization("/api/v0/getOrganizationSubscription/" + organisationId);
    const response = await request.json();
    return response;
}

export async function getCurrentSubscriptionStripeDataForOrganisation(organizationId) {
    const request = await callApiWithAuthorization(
        "/api/v0/organization/" + organizationId + "/stripe/subscription"
    );
    const response = await request.json();
    return response;
}

export async function updateNumberOfSeats(organizationId, subscriptionId, seats, paymentMethodId) {
    const request = await callApiWithAuthorization(`/api/v0/organization/${organizationId}/seats`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            subscriptionId, seats, paymentMethodId
        })
    });
    const response = await request.json();
    return response;
}

export async function updateSubscriptionPrice(organizationId, subscriptionId, priceId, seats, paymentMethodId) {
    const request = await callApiWithAuthorization(
        `/api/v0/organization/${organizationId}/subscription`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                subscriptionId,
                priceId,
                seats,
                paymentMethodId
            }),
        }
    );
    const response = await request.json();
    return response;
}

export async function handleRemovedUsers(organizationId, users) {
    const request = await callApiWithAuthorization(
        "/api/v0/payment/seats/changeAtPeriodEnd",
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                organizationId,
                users,
            }),
        }
    );
    const response = await request.json();
    return response;
}

export async function getSubscriptionParameters(stripeProductId) {
    const request = await callApiWithAuthorization("/api/v0/subscription/" + stripeProductId);
    const response = await request.json();
    return response;
}

export async function getNewPrice(subscriptionId, priceId, numSeats) {
    const request = await callApiWithAuthorization("/api/v0/payment/subscription/newPrice", {
        method: "POST",
        headers: {
            'Content-Type': "application/json"
        },
        body: JSON.stringify({
            subscriptionId,
            priceId,
            numSeats
        })
    });
    const response = await request.json();
    return response;
}

export async function getSetupIntentClientSecret(customerId) {
    const request = await callApiWithAuthorization("/api/v0/payment/setup", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            customerId
        })
    });
    const response = await request.json();
    return response.clientSecret;
}

export async function getNumberOfSubscriptionUser(organizationId) {
    const request = await callApiWithAuthorization("/api/v0/organization/" + organizationId + "/numSubscriptionUser");
    const response = await request.json();
    return response.numberOfSubscriptionUser;
}

export async function getNumberOfActiveProjects(organizationId) {
    const request = await callApiWithAuthorization("/api/v0/organization/" + organizationId + "/numActiveProjects");
    const response = await request.json();
    return response.numberOfActiveProjects;
}

export async function getPaymentMethodById(organizationId, paymentMethodId) {
    const request = await callApiWithAuthorization(`/api/v0/organization/${organizationId}/payment-method/${paymentMethodId}`);
    const response = await request.json();
    return response.paymentMethod;
}

export async function updateExpiry(organizationId, paymentMethodId, expiryMonth, expiryYear) {
    const request = await callApiWithAuthorization(
        `/api/v0/organization/${organizationId}/paymentMethod/${paymentMethodId}`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                expiryMonth, expiryYear
            })
        }
    );
    const response = await request.json();
    return response;
}

export async function updateCustomerDefaultPaymentMethod(organizationId, paymentMethodId) {
    const request = await callApiWithAuthorization("/api/v0/organization/" + organizationId + "/stripe/default-payment-method", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            paymentMethodId
        })
    });
    const response = await request.json();
    return response;
}

export async function getCustomerStripeData(organizationId) {
    const request = await callApiWithAuthorization("/api/v0/organization/" + organizationId + "/stripe/customer");
    const response = await request.json();
    return response;
}

export async function updateCustomer(organizationId, properties) {
    const request = await callApiWithAuthorization("/api/v0/organization/" + organizationId + "/stripe/customer", {
        method: "PUT",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify(properties)
    });
    const response = await request.json();
    return response;
}

export async function addCustomerTaxId(organizationId, taxId) {
    const request = await callApiWithAuthorization("/api/v0/organization/" + organizationId + "/stripe/taxId", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            taxId
        })
    });
    const response = await request.json();
    return response;
}

export async function updateCustomerTaxId(organizationId, taxId, newTaxId) {
    const request = await callApiWithAuthorization("/api/v0/organizationId/" + organizationId + "/stripe/taxId/" + taxId, {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            newTaxId
        })
    });
    const response = await request.json();
    return response;
}

export async function deleteCustomerTaxId(organizationId, taxId) {
    const request = await callApiWithAuthorization("/api/v0/organization/" + organizationId + "/stripe/taxId/" + taxId, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json"
        }
    });
    const response = await request.json();
    return response;
}

export async function deleteCustomerPaymentMethod(organizationId, paymentMethodId) {
    const request = await callApiWithAuthorization(`/api/v0/organization/${organizationId}/stripe/payment-method/${paymentMethodId}`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json"
        }
    });
    const response = await request.json();
    return response;
}

export async function chargeCustomerForInvoice(organizationId, invoiceId, paymentMethodId) {
    const request = await callApiWithAuthorization(
        `/api/v0/organization/${organizationId}/invoice/${invoiceId}/pay`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                paymentMethodId
            })
        }
    );
    const response = await request.json();
    return response;
}

export async function getProjectsWithUserCreateRoles(organizationId) {
    const request = await callApiWithAuthorization("/api/v0/organization/" + organizationId + "/project-with-user-created-roles")
    const response = await request.json();
    return response;
}

export async function chargeCustomerForOpenInvoices(organizationId, paymentMethodId) {
    const request = await callApiWithAuthorization("/api/v0/payment/pay-open-invoice", {
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            organizationId,
            paymentMethodId
        })
    });
    const response = await request.json();
    return response;
}

export async function getNumberOfAssignedSeats(organizationId) {
    const request = await callApiWithAuthorization("/api/v0/organization/" + organizationId + "/num-assigned-seats");
    const response = await request.json();
    return response;
}

export async function getPaymentMethodsOfAnOrganization(organizationId) {
    const request = await callApiWithAuthorization("/api/v0/organization/" + organizationId + "/paymentMethod");
    const response = await request.json();
    return response;
}

/**
 * Function to cancel change of seat in the next phase of subscription schedule
 * @param {string} subscriptionId stripe id of the subscription
 * @returns response from the server
 */
export async function cancelSeatChangeInNextPhase(organizationId, subscriptionId) {
    const request = await callApiWithAuthorization(
        `/api/v0/organization/${organizationId}/subscription/cancel-seat-change`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                subscriptionId
            })
        }
    )
    const response = await request.json();
    return response;
}

/**
 * Function to cancel change of plan in the next phase of subscription schedule
 * @param {string} subscriptionId stripe id of the subscription
 * @returns response from the server
 */
export async function cancelPlanChangeInNextPhase(organizationId, subscriptionId) {
    const request = await callApiWithAuthorization(
        `/api/v0/organization/${organizationId}/subscription/cancel-plan-change`,
        {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                subscriptionId
            })
        }
    )
    const response = await request.json();
    return response;
}